import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import axios from 'axios'

import {
  API_GET_USER_INFO,
  API_LOGIN,
  API_REGISTER,
  SERVICE_AUTH_KEY,
} from '../../../helpers/config/config'

const header = {
  headers: {
    'Content-Type': 'application/json',
    'service-auth-key': `${SERVICE_AUTH_KEY}`,
  },
}

export const getAuth = createAsyncThunk(
  'user/getUser',
  async (
    { email, password }: { email: string; password: string },
    thunkAPI
  ) => {
    try {
      const response = await axios.post(
        `${API_LOGIN}`,
        {
          email: email,
          password: password,
        },
        header
      )

      if (!response.data) {
        throw new Error('error')
      }

      return response.data
    } catch (error) {
      console.error('Error:', error)
      throw error
    }
  }
)

export const registerUser = createAsyncThunk(
  'user/register',
  async (
    {
      name,
      email,
      password,
    }: { name: string; email: string; password: string },
    thunkAPI
  ) => {
    try {
      let userData = {
        name: name,
        email: email,
        password: password,
      }
      const { data } = await axios.post(`${API_REGISTER}`, userData, header)
      return data
    } catch (err) {
      return thunkAPI.rejectWithValue({
        errorMessage: err,
      })
    }
  }
)

export const getInfo = createAsyncThunk(
  'user/getInfo',
  async ({ token }: { token: string | undefined }, thunkAPI) => {
    try {
      const response = await axios.get(`${API_GET_USER_INFO}`, {
        ...header,
        headers: {
          ...header.headers,
          Authorization: `Bearer ${token}`,
        },
      })
      const data = response.data
      return data
    } catch (err) {
      return thunkAPI.rejectWithValue({
        errorMessage: err,
      })
    }
  }
)

interface UserResponse {
  success: boolean
  data: {
    access_token: string
    user: {
      name: string
      email: string
    }
  }
}

interface DataState {
  data: UserResponse
  fetchingData: string
  error: string | null
}

const initialState: DataState = {
  data: {
    success: false,
    data: {
      access_token: '',
      user: {
        name: '',
        email: '',
      },
    },
  },
  fetchingData: 'NO_DATA',
  error: null,
}

export const user = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.fetchingData = 'NO_DATA'
        state.data = initialState.data
        state.error = null
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.fetchingData = 'FETCHED'
        state.data = action.payload
        state.error = null
      })
      .addCase(registerUser.rejected, (state, action: PayloadAction<any>) => {
        state.error = action.payload
      })
      .addCase(getAuth.pending, (state) => {
        state.fetchingData = 'NO_DATA'
        state.data = initialState.data
        state.error = null
      })
      .addCase(getAuth.fulfilled, (state, action) => {
        state.fetchingData = 'FETCHED'
        state.data = action.payload
        state.error = null

        const { name, email } = state.data.data.user
        sessionStorage.setItem('user_email', email)
        sessionStorage.setItem('user_name', name)
      })
      .addCase(getAuth.rejected, (state, action: PayloadAction<any>) => {
        state.error = action.payload
      })
  },
})

export default user.reducer
